"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupScheduleDigestResponse = exports.SignupScheduleDigestRequest = void 0;
var helpers_1 = require("../../helpers");
var SignupScheduleDigestRequest = /** @class */function () {
  function SignupScheduleDigestRequest(values) {
    this.account_id = values.account_id;
    this.user_service_id = values.user_service_id;
    helpers_1.ValueValidation.assertUUIDv4('account_id', this.account_id);
    if (this.user_service_id) {
      helpers_1.ValueValidation.assertUUIDv4('user_service_id', this.user_service_id);
    }
  }
  return SignupScheduleDigestRequest;
}();
exports.SignupScheduleDigestRequest = SignupScheduleDigestRequest;
var SignupScheduleDigestResponse = /** @class */function () {
  function SignupScheduleDigestResponse(values) {
    this.count = Number(values.count);
    this.min_date = values.min_date ? new Date(values.min_date) : null;
    this.max_date = values.max_date ? new Date(values.max_date) : null;
  }
  return SignupScheduleDigestResponse;
}();
exports.SignupScheduleDigestResponse = SignupScheduleDigestResponse;
